import { useAuthStore } from '../../../../../../../store/auth/auth';
import React, { useEffect, useMemo, useState } from 'react';
import { format, parseISO } from 'date-fns';
import { VIDEO_FILE_PREVIEW } from '../../../../../../../api/file/FilePreview';
import { Card, Checkbox, Form, Select } from 'antd';
import { formatDuration } from '../../../../../../../utils/shared/helpers/formatDuration';
import { File } from '../../../../../../../types/File';
import img from '../../../../../../../components/cards/cardComponentFile/Video picture.png';
import imgMicrophone from '../../../../../../../utils/app/assets/images/Radio set.png';
import imgVideo from '../../../../../../../components/layouts/camera/Video.png';

import './styles.css';
import { useFileStore } from '../../../../../../../store/devices/fileStore';
import { useOnlineStateStream } from '../../../../../../../store/devices/onlineStream';
import { SizeType } from 'antd/es/config-provider/SizeContext';
import { useFileSelectionStore } from '../../../../../../../store/devices/useSelectedRowKeysFilesRS';
import { useOpenMoreDetails } from '../../../../../../../store/devices/useShowMoreDetails';
import { useSelectedFile } from '../../../../../../../store/devices/getSelectedFile';
import { ratingOptions } from '../ArchiveFilters/consts/consts';
import usePTTMessageStore, {
    PTTMessage,
} from '../../../../../pttDispatcher/api/usePttMessageStore';
import { isPTTMessage } from '../../helpers/consts/consts';
import {
    formatDateTime,
    safeTimestamp,
    safeTimestampTwo,
} from '../../../../../pttDispatcher/helpers/formatDateTime';
import Tag from '../../../../../../../utils/shared/components/Tags/Tag';
import { useGroupsStore } from '../../../../../../../store/groups/Groups';
import { useOwnerStore } from '../../../../../../../store/owner/useOwnerStore';
import { usePTTGroupsStore } from '../../../../../../../store/pttGroups/usePTTGroupsStore';
import { useOperator } from '../../../../../../../store/users/Operators';
import { useDevicesStore } from '../../../../../../../store/devices/allDevices';

interface CardFileProps {
    item: File | PTTMessage;
    isSelected: boolean;
    onCheckboxChange: (fileId: string, checked: boolean) => void;
    onClick: (file: File | PTTMessage) => void;
    contentType: 'files' | 'radiochat';
}

const CardFile: React.FC<CardFileProps> = ({
    item,
    isSelected,
    onCheckboxChange,
    onClick,
    contentType,
}) => {
    const { user, SmartDVRToken } = useAuthStore();
    const [previewUrl, setPreviewUrl] = useState<string>('');
    const [isLoading, setIsLoading] = useState(false);
    const { setSelectedFileUID } = useFileStore();
    const { setIsStreamOnline } = useOnlineStateStream();
    const [previewUrlVideo, setPreviewUrlVideo] = useState<string>('');
    const [previewUrlJpg, setPreviewUrlJpg] = useState<string>('');
    const [size] = useState<SizeType>('middle');
    const [mediaUrl, setMediaUrl] = useState<string>('');
    const { selectedFile, setSelectedFile } = useSelectedFile();

    const { selectedFiles, setSelectedFiles } = useFileSelectionStore();
    const { setOpenMoreDetails } = useOpenMoreDetails();
    const { groups, fetchGroups } = useGroupsStore();
    const { owners, fetchOwners } = useOwnerStore();
    const { groups: pttGroups, fetchGroups: fetchPttGroups } = usePTTGroupsStore();
    const { users: operators, fetchUsers: fetchOperators } = useOperator();
    const { devices, fetchDevices } = useDevicesStore();

    // Форматирование даты
    const formatDate = (isoDate: string): string => {
        const parsedDate = parseISO(isoDate);
        const adjustedDate = new Date(parsedDate.getTime() - 5 * 60 * 60 * 1000);
        return format(adjustedDate, 'dd.MM.yy - HH:mm:ss');
    };

    // Получение превью файла
    useEffect(() => {
        if (!isPTTMessage(item)) {
            const fetchPreview = async () => {
                if (user?.login) {
                    setIsLoading(true);
                    try {
                        const preview = await VIDEO_FILE_PREVIEW(
                            item.UID,
                            SmartDVRToken,
                            user.login,
                        );
                        if (item.fileType === 'jpg') {
                            setPreviewUrlJpg(preview);
                        }
                        setPreviewUrl(preview);
                    } catch (error) {
                        console.error('Error fetching preview:', error);
                    } finally {
                        setIsLoading(false);
                    }
                }
            };
            fetchPreview();
        }
    }, [item, SmartDVRToken, user]);

    const handleClick = () => {
        if (isPTTMessage(item)) {
            // Для радиочата используем другую модалку
            setSelectedFile(item);
            setOpenMoreDetails(true);
        } else {
            // Для обычных файлов оставляем как есть
            // setSelectedFileUID(item.UID);

            // setIsStreamOnline(false);
            setSelectedFile(item);

            setOpenMoreDetails(true);

            // onClick(item);
        }
    };

    let displayDate;

    if (!isPTTMessage(item)) {
        displayDate = formatDate(item.start);
        // displayDate = item.start;
    } else {
        console.log(item);
        displayDate = formatDate(safeTimestampTwo(item.timestamp));
    }

    const groupName = useMemo(() => {
        if (!isPTTMessage(item)) return null;

        // Ищем группу в разных местах
        return (
            item.group?.name ||
            pttGroups?.find((g) => g.uid === item.recipient.id)?.name ||
            'Группа не указана'
        );
    }, [item, pttGroups]);

    if (isPTTMessage(item)) {
        // console.log(item);
        return (
            <div className="containerCardFile archive" onClick={() => handleClick()}>
                <div className="coverFile archive">
                    <Card
                        className="coverCardFile archive"
                        key={item.uid}
                        cover={
                            <img style={{ width: 49, height: 70 }} src={imgMicrophone} alt={''} />
                        }
                    />
                </div>
                <div className="propertiesFile">
                    <h1 className="nameFile title medium">
                        {displayDate}
                        {/*{item.fileType !== 'jpg' && (*/}
                        {/*    <span*/}
                        {/*        className={'body medium'}*/}
                        {/*        style={{ color: 'var(--gray-01)', marginLeft: 8 }}*/}
                        {/*    >*/}
                        {/*        ({formatDuration(item.duration)})*/}
                        {/*    </span>*/}
                        {/*)}*/}
                    </h1>
                    <Tag border={true} state={'default'}>
                        {groupName}
                    </Tag>
                    <div className="propertyGroupFile">
                        <div className="urgentSet">
                            <span
                                className={'body medium'}
                                style={{ color: 'var(--gray-01)', marginTop: 16 }}
                            >
                                {item.sender.name} - {item.recipient.name}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    const handleError = (e: React.SyntheticEvent<HTMLImageElement>) => {
        e.currentTarget.src = imgVideo;
    };

    const handleErrorAudio = (e: React.SyntheticEvent<HTMLImageElement>) => {
        e.currentTarget.src = imgMicrophone;
    };

    return (
        <div className="containerCardFile archive" onClick={() => handleClick()}>
            <div className="coverFile">
                <Card
                    className="coverCardFile"
                    key={item.UID}
                    cover={
                        item.fileType === 'jpg' ? (
                            <img
                                className="imgPreview"
                                src={previewUrlJpg}
                                alt={'Превью не найдено'}
                                onError={handleError}
                            />
                        ) : item.fileType === 'mp4' || item.fileType === 'mpd' ? (
                            <img
                                className="imgPreview"
                                alt={'Превью не найдено'}
                                src={previewUrl}
                                onError={handleError}
                            />
                        ) : (
                            <img
                                className="imgPreview"
                                src={img}
                                alt={'Превью не найдено'}
                                onError={handleErrorAudio}
                            />
                        )
                    }
                />
            </div>
            <div className="propertiesFile">
                <h1 className="nameFile">
                    {displayDate}
                    {item.fileType !== 'jpg' && (
                        <span
                            className={'body medium'}
                            style={{ color: 'var(--gray-01)', marginLeft: 8 }}
                        >
                            ({formatDuration(item.duration)})
                        </span>
                    )}
                </h1>
                <div className="propertyGroupFile">
                    <h3 className="propertyFile archive">{item.size.toFixed(1)} мБ</h3>
                    <div className="urgentSet">
                        <Tag border={true} state={'default'}>
                            {ratingOptions.find((option) => option.value === item.rating)?.label ||
                                `Неизвестный уровень: ${item.rating}`}
                        </Tag>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CardFile;
